import React from 'react';
import useIntersectionObserver from '../../hooks/useIntersectionObserver';
import './Process.scss';

const Step = ({ number, title, desc }) => {
  const [ref, isInView] = useIntersectionObserver();
  return (
    <div ref={ref} className={`step fade-in-section ${isInView ? 'in-view' : ''}`}>
      <div className="step-number">{number}</div>
      <div className="step-content">
        <h4>{title}</h4>
        <p>{desc}</p>
      </div>
    </div>
  );
};

const Process = () => {
  return (
    <section id="process" className="section-padding">
      <div className="process-inner max-width">
        <div className="process-header">
          <div className="process-badge">Our Process</div>
          <h2>How We Work Our Magic</h2>
          <p className="process-subtitle">A proven methodology that delivers extraordinary results every time.</p>
          
          <div className="process-stats">
            <div className="stat-item">
              <div className="stat-number">6</div>
              <div className="stat-label">Strategic Steps</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">100%</div>
              <div className="stat-label">Transparent Process</div>
            </div>
          </div>
          
          <div className="process-features">
            <div className="feature-item">
              <svg className="feature-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
              <span>Data-Driven Decisions</span>
            </div>
            <div className="feature-item">
              <svg className="feature-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
              <span>Continuous Optimization</span>
            </div>
            <div className="feature-item">
              <svg className="feature-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
              <span>Weekly Reporting</span>
            </div>
          </div>
          
          <div className="process-decoration">
            <div className="decoration-circle"></div>
            <div className="decoration-circle"></div>
            <div className="decoration-circle"></div>
          </div>
        </div>
        <div className="process-steps">
          <Step number="01" title="Discover & Diagnose" desc="Understand your market, audience, and current performance." />
          <Step number="02" title="Tracking & Analytics" desc="Set up analytics, pixels, and conversion tracking." />
          <Step number="03" title="Strategy & Blueprint" desc="Define KPIs, channel strategy, budget, and testing plan." />
          <Step number="04" title="Build & Launch" desc="Execute PPC, SEO, and social with a scalable structure." />
          <Step number="05" title="Content & Creative" desc="Produce high-converting creatives, copy, and posts." />
          <Step number="06" title="Optimize & Scale" desc="Weekly improvements, reporting, and scaling what works." />
        </div>
      </div>
    </section>
  );
};

export default Process;